<template>
  <el-dialog
    title="修改密码"
    width="580px"
    :close-on-click-modal="false"
    :visible.sync="showDialog"
    :destroy-on-close="true"
    @close="close()"
  >
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="80px" label-position="left">
      <el-form-item label="旧密码" prop="oldPassword" >
        <el-input v-model="formData.oldPassword" autocomplete="new-password" show-password placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="password" >
        <el-input v-model="formData.password" autocomplete="new-password" show-password placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input v-model="formData.confirmPassword" autocomplete="new-password" show-password placeholder="请输入" clearable></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button size="medium" @click="showDialog = false">取消</el-button>
      <el-button size="medium" type="primary" :loading="submitLoading" @click="onSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import userService from "../../components/service/UserService";
import { verifyPass } from '@/utils/validate';
import { changePassword } from '@/api/user';
import { passwordBymd5 } from '@/utils/index';

export default {
  data() {
    const validatePass1 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('新密码不能为空'));
        return;
      }
      const { isReg, regTxt } = verifyPass(value);
      if (!isReg) {
        callback(new Error(regTxt));
        return;
      }
      if (this.formData.confirmPassword !== '') {
        this.$refs.formRef.validateField('confirmPassword');
      }
      callback();
    };
    const validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formData.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      showDialog: false,
      formData: {
        oldPassword: null,
        password: null,
        confirmPassword: null,
      },
      rules: {
        oldPassword: { required: true, message: '旧密码不能为空', trigger: 'blur' },
        password: [
          { required: true, validator: validatePass1, trigger: 'blur'},
        ],
        confirmPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }],
      },
      updateData: {
        username: this.username, // 要修改的用户名
        force: false, // 是否为强制修改密码，此时storage中未保存token
        token: '', // 强制修改密码时的token（即登录成功后密码过期时，本次登录的token）
      },
      submitLoading: false,
    };
  },
  methods: {
    openDialog: function (data) {
      this.showDialog = true;
      this.updateData = data;
    },
    onSubmit: function () {
      this.$refs.formRef.validate(async (vali) => {
        if (!vali) return;
        this.submitLoading = true;
        const params = {
          oldPassword: passwordBymd5(this.formData.oldPassword),
          password: this.formData.password,
          username: this.updateData.username,
        };
        try {
          await changePassword(params, this.updateData.force, this.updateData.token);
          this.$message.success('密码修改成功，请重新登录');
          userService.clearUserInfo();
          this.showDialog = false;
          this.$router.push('/login');
        } catch (e) {
          this.submitLoading = false;
        }
      })
    },
    close: function () {
      this.showDialog = false;
      this.submitLoading = false;
      this.updateData = {};
      this.$refs.formRef.resetFields();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layout/components/changePassword.vue